// components
import { styled, Box, Button, ButtonProps } from '@mui/material';

// external libraries
import { MotionGrowDown } from './SpecialLeaveTable.motion';

export const StyledContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEditable'
})<{ isEditable?: boolean }>(({ theme, isEditable }) => ({
  '& section': {
    marginBottom: 0,
    paddingBottom: isEditable ? 0 : theme.spacing(4)
  }
}));

export const StyledEmptyFeedbackBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEditable'
})<{ isEditable?: boolean }>(({ theme, isEditable }) => ({
  padding: theme.spacing(8, 4),
  color: theme.palette.text.secondary,
  backgroundColor: '#fcf9f6', // custom alternative warning bg color
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  alignItems: 'center',
  marginTop: isEditable ? theme.spacing(4) : 0,
  borderRadius: theme.shape.borderRadius,

  '& svg ': {
    width: '40px',
    height: '40px'
  }
}));

export const StyledAddButton = styled(Button)<ButtonProps>(() => ({
  width: 'max-content'
}));

export const StyledAddRowMotionBox = styled(MotionGrowDown)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'stretch',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 1, 1),
  overflow: 'hidden',

  '& .MuiIconButton-root': {
    padding: theme.spacing(1.5),
    alignItems: 'stretch'
  }
}));
